import { render, staticRenderFns } from "./RcvN.vue?vue&type=template&id=6cdc516d"
import script from "./RcvN.vue?vue&type=script&lang=js"
export * from "./RcvN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports